import jsonAPI from './json-api'

class Course {
  constructor () {
    this._conf = {
      baseURL: '/api/v1',
      method: 'post'
    }
  }

  // 首页课程列表
  list (param) {
    return jsonAPI.requestWithAuth('/getHomeVideos', param, this._conf)
  }

  // 课程分类
  courseCategory (param) {
    return jsonAPI.requestWithAuth('/getVideoCategory', param, this._conf)
  }

  // 课程详情
  detail (param) {
    return jsonAPI.requestWithAuth('/getVideoInfoById', param, this._conf)
  }

  // 课程视频地址
  video (param) {
    return jsonAPI.requestWithAuth('/getPlayUrlByVideoId', param, this._conf)
  }

  // banner右侧课程top3
  carouselCourseList () {
    return jsonAPI.requestWithAuth('/getBannerVideo', {}, this._conf)
  }

  // 保存课程观看记录
  saveWatchedTime (param) {
    return jsonAPI.requestWithAuth('/watchedRecord', param, this._conf)
  }

  // 播放记录列表
  watchedRecordList () {
    return jsonAPI.requestWithAuth('/watchedRecordList', {}, this._conf)
  }

  // 搜索结果列表
  searchResultList (param) {
    return jsonAPI.requestWithAuth('/searchVideos', param, this._conf)
  }
}

export default new Course()
